import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Image from '../../elements/Image';

const Logo = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'brand',
    className
  );

  return (
    <div
      {...props}
      className={classes}
    >
      <div className="m-0">
        <Link to="/">
          <Image
            src={require('./../../../assets/images/logo_line.avif')}
            alt="Tilak.io"
            width={254}
            height={254} />
        </Link>
      </div>
    </div>
  );
}

export default Logo;
